export function fErrors(msg, errors) {
  let err = errors;
  if (errors.data && typeof errors.data === 'object') {
    if (errors.data.errors) {
      err = errors.data.errors;
    } else if (errors.data.message) {
      err = errors.data.message;
    } else if (errors.data.error) {
      err = errors.data.error;
    }

    if (errors.data.status) {
      err = errors.data.status;
      const errorMsg = msg({ id: `error_${errors.data.status}` });
      if (errorMsg) {
        err = errorMsg;
      }
    }
  } else if (errors.status) {
    err = errors.status;
    const errorMsg = msg({ id: `error_${errors.status}` });
    if (errorMsg) {
      err = errorMsg;
    }
  }
  if (!err) {
    err = errors.error;
  }
  if (Array.isArray(err)) {
    return err.reduce((result, curVal) => {
      const { message, property } = curVal;
      let curMsg = message;
      if (message.includes('UNIQUE')) {
        curMsg = msg({ id: `unique.${property}` });
      }
      return `${result}\n${curMsg}`;
    }, '');
  }
  return err;
}
